<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h4>Network Settings</h4>
      </div>
    </div>
    <div class="row" v-if="[3, 4].includes(logged_in_user.group_id)">
      <div class="col-8">
        <div class="alert alert-danger" role="alert">
          <b>Warning:</b> If incorrect data is entered here, you will need physical access to the machine to fix it.
        </div>
        <div class="alert alert-warning" role="alert">
          <b>Notice:</b> Changing Network Settings requires that the machine be restarted to take effect.
        </div>
        
        <form>
          <p>Can't find the right network interface? <a href="#" @click="showAddNeworkInterfaceModal()">Add it here.</a></p>
          <div v-for="network_interface in network_interfaces" :key="network_interface.network_interface_id">
            <h5>{{ network_interface.name }}</h5>
            <div class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" v-model="network_interface.enabled">
                Enabled
              </label>
            </div>
            <div class="form-group">
              <label>IP Assignment</label>
              <select class="form-control" v-model="network_interface.type">
                <option value="1">Static</option>
                <option value="2">DHCP</option>
                <option value="3">Unconfigured</option>
              </select>
            </div>
            <div v-if="showConfig(network_interface.type)">
              <div class="form-group">
                <label>IP</label>
                <input type="text" class="form-control" v-model="network_interface.ip">
              </div>
              <div class="form-group">
                <label>Netmask</label>
                <input type="text" class="form-control" v-model="network_interface.netmask">
              </div>
              <div class="form-group">
                <label>Gateway</label>
                <input type="text" class="form-control" v-model="network_interface.gateway">
              </div>
            </div>
            <br><br>
          </div>

          <button type="submit" class="btn btn-hub-primary" @click="save()">Save</button>
        </form>
      </div>
    </div>

    <div class="row" v-else>
      <div class="col-8">
        <form>
          <div v-for="network_interface in network_interfaces" :key="network_interface.network_interface_id">
            <h5>{{ network_interface.name }}</h5>
            <div class="form-check">
              <label class="form-check-label">
                <input type="checkbox" class="form-check-input" v-model="network_interface.enabled" disabled>
                Enabled
              </label>
            </div>
            <div class="form-group">
              <label>IP Assignment</label>
              <select class="form-control" v-model="network_interface.type" disabled>
                <option value="1">Static</option>
                <option value="2">DHCP</option>
                <option value="3">Unconfigured</option>
              </select>
            </div>
            <div v-if="showConfig(network_interface.type)">
              <div class="form-group">
                <label>IP</label>
                <input type="text" class="form-control" v-model="network_interface.ip" disabled>
              </div>
              <div class="form-group">
                <label>Netmask</label>
                <input type="text" class="form-control" v-model="network_interface.netmask" disabled>
              </div>
              <div class="form-group">
                <label>Gateway</label>
                <input type="text" class="form-control" v-model="network_interface.gateway" disabled>
              </div>
            </div>
            <br><br>
          </div>

          <button type="submit" class="btn btn-hub-primary" @click="save()">Save</button>
          
        </form>
      </div>
    </div>

    <Modal :modal_id="'addNetworkDeviceModal'">
      <template v-slot:title>
        Add Custom Network Interface
      </template>
      <template v-slot:body>
        <div>
          <div>
            <div class="col-8">
              <div class="alert alert-info" role="alert">
                <b>Note:</b> You can only add one network interface at a time. If you are attemping to add additional network interfaces, save the previous one and then reopen this dialog.
              </div>
              <form id="addNetworkInterfaceForm">
                <div class="form-group">
                  <label for="txtNetworkInterface">Network Interface Name</label>
                  <input required type="text" class="form-control" id="txtNetworkInterface" v-model="new_network_interface.name">
                </div>
                <div class="form-check">
                  <label class="form-check-label">
                    <input type="checkbox" class="form-check-input" v-model="new_network_interface.enabled">
                    Enabled
                  </label>
                </div>
                <div class="form-group">
                  <label>IP Assignment</label>
                  <select class="form-control" v-model="new_network_interface.type">
                    <option value="1">Static</option>
                    <option value="2">DHCP</option>
                    <option value="3">Unconfigured</option>
                  </select>
                </div>
                <div v-if="showConfig(new_network_interface.type)">
                  <div class="form-group">
                    <label>IP</label>
                    <input type="text" class="form-control" id="txtIP" v-model="new_network_interface.ip" required>
                  </div>
                  <div class="form-group">
                    <label>Netmask</label>
                    <input type="text" class="form-control" id="txtNetmask" v-model="new_network_interface.netmask" required>
                  </div>
                  <div class="form-group">
                    <label>Gateway</label>
                    <input type="text" class="form-control" id="txtGateway" v-model="new_network_interface.gateway" required>
                  </div>
                </div>
                
                <button type="submit" class="btn btn-hub-primary" @click="addNetworkInterface()">Add</button>
              </form>
            </div>
          </div>
        </div>
      </template>
    </Modal>

  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Modal from '../../../components/Modal.vue'

export default {
  name: 'network',
  components: {
    Modal
  },
  data: function () {
    return {
      selected_network_interface_id: '1',
      new_network_interface: {
        network_interface_id: 0,
        name: '',
        wired: true,
        enabled: true,
        type: 2,
        ip: '',
        netmask: '',
        gateway: ''
      }
    }
  },
  computed: mapGetters({
    network_interfaces: 'allNetworkInterfaces',
    logged_in_user: 'loggedInUser',
  }),
  created () {
    this.$store.dispatch('getNetworkInterfaces')
  },
  methods: {
    showConfig (type) {
      return type === '1' || type === 1
    },
    validNetworkInterface() {
      if (!txtNetworkInterface.checkValidity()) {
        return false;
      }

      if (this.showConfig(this.new_network_interface.type)) {
        if (!txtIP.checkValidity()) {
          return false;
        }
        if (!txtNetmask.checkValidity()) {
          return false;
        }
        if (!txtGateway.checkValidity()) {
          return false;
        }
      }
      return true;
    },
    save () {
      // Skip adding the new network interface if it is not valid by using a null value.
      let network_interface_to_add = null
      if (this.validNetworkInterface()) {
        network_interface_to_add = this.new_network_interface
      }

      this.$store.dispatch('saveNetworkInterfaces', { "network_interfaces": this.network_interfaces, "network_interface": network_interface_to_add })
    },
    addNetworkInterface () {
      if (!this.validNetworkInterface()) {
        return;
      }

      $('#addNetworkDeviceModal').modal('hide')

      // Don't add it again if it already exists. Update the values instead.
      if (!this.network_interfaces.some(x => x.network_interface_id === 0))
        this.network_interfaces.push(this.new_network_interface)
      else {
        this.new_network_interface = this.network_interfaces.find(x => x.network_interface_id === 0)
        this.new_network_interface.name = this.new_network_interface.name
        this.new_network_interface.enabled = this.new_network_interface.enabled
        this.new_network_interface.type = this.new_network_interface.type
        this.new_network_interface.ip = this.new_network_interface.ip
        this.new_network_interface.netmask = this.new_network_interface.netmask
        this.new_network_interface.gateway = this.new_network_interface.gateway
      }
    },
    showAddNeworkInterfaceModal () {
      $('#addNetworkDeviceModal').modal('show')
    }
  }
}
</script>

<style scoped>
</style>
